<style scoped lang="scss">
  @import "../user";
  .text-error{
    color: #F56C6C;
  }
  .score {
    h1{
      font-size: 26px;
      font-weight: bold;
      margin-bottom: 5px;
      &.disabled{
        color: #98aec9;
      }
      &.enabled{
        color: #466a98;
      }
    }
  }
  .success{
    color: #0f9d58;
  }
  .error{
    color: #990000;
  }
  h3.title{
    margin-top: 32px;
    color: #444144;
  }
  .tipText{
    font-size: 12px;
    color: #d5d2d5;
    margin-top: 5px;
  }
  .dividerBorder{
    width: 1px;
    background: #EFEFEF;
  }
  .staticItem{
    width: 35%;
  }
  .debt-color{
    color: #d9001b !important;
  }
  @media screen and (max-width: 640px){
    h3.title{
      font-size: 20px!important;
      margin-top: 32px;
    }
    .text-primary{
      line-height: 25px;
    }
  }
</style>
<template>
  <div class="user">
    <section>
      <h3 class="title">积分获取/兑换记录</h3>
<!--      <p>当前可用积分：<span class="text-primary mr30">{{points.availablePoints}}</span>待解锁积分：<span class="text-primary">{{points.lockedPoints}}</span></p>-->

      <div class="score flex flex-justify-space-around" :style="{marginBottom: '10px'}">
        <div v-if="points.availablePoints > 0" class="flex flex-justify-center flex-align-center flex-direction-col staticItem">
          <h1 class="enabled">{{points.availablePoints}}</h1>
          <span>可用积分</span>
          <span class="tipText">(仅用于积分商城商品兑换)</span>
        </div>
        <div v-else class="flex flex-justify-center flex-align-center flex-direction-col staticItem">
          <h1 class="enabled debt-color">{{points.availablePoints}}</h1>
          <span>您已预支{{points.availablePoints}}积分</span>
          <span class="tipText debt-color">(新的积分解锁后将优先抵扣预支积分)</span>
        </div>
        <div class="dividerBorder"></div>
        <div class="flex flex-justify-center flex-align-center flex-direction-col staticItem">
          <h1 class="disabled">{{points.lockedPoints}}</h1>
          <span>待解锁积分</span>
          <span class="tipText">(当前待解锁积分为估算量，具体解锁积分以订单结算金额为准)</span>
        </div>
      </div>
      <el-table
        class="mt20"
        :border="true"
        :header-cell-style="tableHeaderStyle"
        :cell-style="tableCellStyle"
        :data="tableData">
        <el-table-column
          prop="adjustPoint"
          :width="160"
          label="积分账户">
          <template slot-scope="scope">
            <span v-if="scope.row.adjustPoint === 0">{{ scope.row.adjustPoint }}</span>
            <template v-else>
              <a :class="scope.row.adjustPoint > 0 ? 'success' : 'error'">
                {{ scope.row.adjustPoint > 0 ? '+' + scope.row.adjustPoint : ''+ scope.row.adjustPoint}}
              </a>
            </template>

          </template>
        </el-table-column>
        <el-table-column
          :width="220"
          label="时间">
          <template slot-scope="scope">{{scope.row.adjustDate | rTime}}</template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="说明">
          <template slot-scope="scope">

            <a v-if="scope.row.orderType && ['SEQUENCING_ORDER', 'PRODUCT_ORDER', 'PRIMER_ORDER'].indexOf(scope.row.orderType) >= 0" @click="goOrder(scope.row)" :style="{cursor: 'pointer'}">
              {{ scope.row.orderType ? orderStatus[scope.row.orderType] + ':' : '' }}{{ scope.row.remark }}
            </a>
            <span v-else>
              {{ scope.row.orderType ? orderStatus[scope.row.orderType] + ':' : '' }}{{ scope.row.remark }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="page tr">
        <el-pagination
          layout="total, sizes, prev, pager, next"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="changePage">
        </el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
import { customerPoints, pointsLogs } from '@/services/api.index'
import { orderStatus } from '@/utils/constants'
import {
  tableHeaderStyle,
  tableCellStyle
} from '@/settings/table'
export default {
  data() {
    return {
      orderStatus,
      tableHeaderStyle,
      tableCellStyle,
      points: {},
      tableData: [],
      total: 0,
      page: 0,
      size: 10
    }
  },
  created() {
    this.getPoints()
    this.getRecords()
  },
  methods: {
    goOrder(row) {
      let path = ''
      switch (row.orderType) {
        case 'SEQUENCING_ORDER':
          path = '/user/sanger_details?id=' + row.orderId
          break
        case 'PRODUCT_ORDER':
          path = '/user/molecular_details?id=' + row.orderId
          break
        case 'PRIMER_ORDER':
          path = '/user/primer_details?id=' + row.orderId
          break
        default:
          path = ''
          return false
      }
      if (path !== ''){
        this.$router.push(path)
      }
    },
    getPoints () {
      customerPoints().then(res => {
        this.points = res.data
      })
    },
    // 积分记录
    getRecords () {
      pointsLogs(this.page, this.size).then(res => {
        this.tableData = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getRecords()
    },
    handleSizeChange(pageSize) {
      this.size = pageSize
      this.getRecords()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/children/integral_get.vue